'use client'

import type React from 'react'
import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material'

export const SidebarFiltersSkeleton: React.FC = () => {
  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Stack spacing={2}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
        </Box>
        <Divider />

        <Typography variant="h6" component="div">
          Menu
        </Typography>

        <Stack spacing={3}>
          <Stack spacing={1}>
            <Skeleton variant="text" width={60} height={20} />
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={90} height={32} sx={{ borderRadius: 2 }} />
            </Stack>
          </Stack>

          <Stack spacing={1}>
            <Skeleton variant="text" width={80} height={20} />
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Skeleton variant="rectangular" width={70} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={85} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={110} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={95} height={32} sx={{ borderRadius: 2 }} />
            </Stack>
          </Stack>

          <Stack spacing={1}>
            <Skeleton variant="text" width={70} height={20} />
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Skeleton variant="rectangular" width={90} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={75} height={32} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={105} height={32} sx={{ borderRadius: 2 }} />
            </Stack>
          </Stack>
        </Stack>

        <Divider />

        <Typography variant="h6" component="div">
          Filters
        </Typography>

        <Stack spacing={1}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Skeleton variant="text" width={80} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Skeleton variant="rectangular" width={90} height={32} sx={{ borderRadius: 2 }} />
            <Skeleton variant="rectangular" width={110} height={32} sx={{ borderRadius: 2 }} />
            <Skeleton variant="rectangular" width={85} height={32} sx={{ borderRadius: 2 }} />
            <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 2 }} />
            <Skeleton variant="rectangular" width={75} height={32} sx={{ borderRadius: 2 }} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
